<template>
  <v-card-text>
    <v-layout class="align-center">
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-chip class="clickable info--text" label small v-on="on">
            {{ labels[formatType].label }}
            <v-icon color="info">arrow_drop_down</v-icon>
          </v-chip>
        </template>
        <v-list>
          <v-list-tile @click="formatType = 'every'">
            <v-list-tile-content>
              <v-list-tile-title>Every</v-list-tile-title>
              <!-- <v-list-tile-sub-title>Repeat every few minutes at the specified interval.</v-list-tile-sub-title> -->
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="formatType = 'atSpecific'">
            <v-list-tile-content>
              <v-list-tile-title>At</v-list-tile-title>
              <!-- <v-list-tile-sub-title>Occur at specific minutes.</v-list-tile-sub-title> -->
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="formatType = 'betweenRange'">

            <v-list-tile-content>
              <v-list-tile-title>Between</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="formatType = 'custom'">
            <v-list-tile-content>
              <v-list-tile-title>Custom</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
      <template v-if="formatType == 'every'">
        <!-- <input style="width: 20px;" :class="{ 'error--text': !validation.every.isValid, 'ml-2 py-1 pl-1 cron-input': true}" disabled value="*/" /> -->
        <input @input="calculateValue()" @keydown.space.prevent style="width: 50px;" :class="{ 'error--text': !validation.every.isValid, 'mr-2 py-1 pr-1 cron-input': true }" type="number" v-model.number="val.every" hide-details />
        {{ val.every == 1 ? 'month' : 'months' }}
      </template>
      <template v-else-if="formatType == 'atSpecific'">
        At <input @input="calculateValue()" @keydown.space.prevent style="width: 50px;" class="mx-2 pa-1 cron-input" type="number" min="0" max="60" v-model.number="val.atSpecific" hide-details />
        months past the month
      </template>
      <template v-else-if="formatType == 'betweenRange'">
        Between
        <input @input="calculateValue()" @keydown.space.prevent style="width: 50px;" class="mx-2 pa-1 cron-input" type="number" v-model.number="val.betweenMonthsStart" />
        and
        <input @input="calculateValue()" @keydown.space.prevent style="width: 50px;" class="mx-2 pa-1 cron-input" type="number" v-model.number="val.betweenMonthsEnd" hide-details />
        past the month
      </template>
      <template v-else-if="formatType == 'custom'">
        A custom, comma-delimited combination of the above:
        <input @input="calculateValue()" @keydown.space.prevent style="width: 200px; text-align: left;" class="mx-2 pa-1 cron-input" v-model="val.custom" hide-details />
      </template>
    </v-layout>
  </v-card-text>
</template>

<script>
  const everyRegexLax = /^(\*)([^\s^\,]*)$/g
  const everyRegexCorrect = /^(\*)(\/([1-9]|1[0-2]))?$/g

  const atSpecificLax = /^(\d)*$/g
  const atSpecificCorrect = /^([1-9]|1[0-2])$/g

  const betweenMonthsLax = /^([\d]*)-([\d]*)$/g
  const betweenMonthsCorrect = /^([1-9]|1[0-2])-([1-9]|1[0-2])$/g

  const customLax = /^((\d+,)+\d+|(\d+-\d+,?)|\d+|(\*(\/\d+)?),?)+$/g
  const customCorrect = /^(([1-9]|1[0-2]+,)+[1-9]|1[0-2]+|([1-9]|1[0-2]+-[1-9]|1[0-2]+,?)|[1-9]|1[0-2]+|(\*(\/[1-9]|1[0-2]+)?),?)+$/g

  const normalizeOutput = (val) => val.toString().replace(' ', '')

  export default {
    props: {
      value: [String],
    },
    data: () => ({
      formatType: 'every',
      labels: {
        every: {
          label: 'Every',
        },
        atSpecific: {
          label: 'At ',
        },
        betweenRange: {
          label: 'Between',
        },
        custom: {
          label: 'Custom',
        },
      },
      validation: {
        every: {
          isValid: true,
          message: 'Invalid syntax',
        },
        atSpecific: {
          isValid: true,
        },
        betweenMonths: {
          isValid: true,
        },
        custom: {
          isValid: true,
        },
      },
      val: {
        every: 5,
        atSpecific: 10,
        betweenMonthsStart: 10,
        betweenMonthsEnd: 12,
        custom: '*/10,10-12',
      },
      output: null,
    }),
    watch: {
      value: {
        immediate: true,
        handler(val) {
          Object.values(this.validation).forEach(item => item.isValid = true)
          let match

          if (this.formatType != 'custom') {
            match = val.match(everyRegexLax)
            if (match) {
              this.formatType = 'every'
              match = val.match(everyRegexCorrect)
              if (!match) this.validation.every.isValid = false

              let normalized = val.replace('*', '')
              if (normalized.trim().length == 0) normalized = '1'
              else normalized = normalized.replace('/', '')

              this.val.every = normalized
              return
            }

            match = val.match(atSpecificLax)
            if (match) {
              this.formatType = 'atSpecific'
              this.val.atSpecific = val
              match = val.match(atSpecificCorrect)
              if (!match) this.validation.atSpecific.isValid = false
              return
            }

            match = val.match(betweenMonthsLax)
            if (match) {
              this.formatType = 'betweenMonths'
              let split = val.split('-')
              this.val.betweenMonthsStart = split[0]
              this.val.betweenMonthsEnd = split[1]
              match = val.match(betweenMonthsCorrect)
              if (!match) this.validation.betweenMonths.isValid = false
              return
            }
          }

          match = val.match(customLax)
          if (match) {
            this.formatType = 'custom'
            this.val.custom = val

            match = val.match(customCorrect)
            if (!match) this.validation.custom.isValid = false
            return
          } else {
            this.validation.custom.isValid = false
          }
        },
      },
      output(val) {
        this.$emit('input', val)
      },
      validation: {
        deep: true,
        handler(val) {
          let error = Object.values(val).some(item => !item.isValid)
          this.$emit('isValid', !error)
        },
      },
    },
    methods: {
      calculateValue() {
        switch (this.formatType) {
        case 'every':
          this.output = '*/' + normalizeOutput(this.val.every)
          break
        case 'atSpecific':
          this.output = normalizeOutput(this.val.atSpecific.toString())
          break
        case 'betweenMonths':
          this.output = normalizeOutput(this.val.betweenMonthsStart + '-' + this.val.betweenMonthsEnd)
          break
        case 'custom':
          this.output = normalizeOutput(this.val.custom.toString())
          break
        default:
          this.output = '*'
          break
        }
      },
    },
  }
</script>

<style scoped>
  .cron-input {
    background-color: #f3f3f3;
    flex-grow: 0;
    text-align: center;
  }
</style>